module.exports = __webpack_public_path__ + "img/garage-overhang.02b26337.webp";